import { render, staticRenderFns } from "./AverageItem.vue?vue&type=template&id=511388f5"
import script from "./AverageItem.vue?vue&type=script&lang=js"
export * from "./AverageItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports